// @flow
import { componentFactory } from '../component-factory';

export const Title = componentFactory('h1', () => ({
  fontFamily: '"Noto Sans", "Open Sans", OpenSans, Arial, "Helvetica Neue", Helvetica, sans-serif',
  fontSize: '1.8em',
  color: '#2f4a75',
  fontWeight: '500',
}));
